export default __webpack_public_path__ + "2cea7a713f9116ee978ed8ce3cfd7a9b.png";